<form [formGroup]="form" (ngSubmit)="submit()">
  <mat-horizontal-stepper #stepper linear="true">
    <mat-step *ngFor="let step of steps; let index = index; let last = last;" >
      <ng-template matStepLabel>{{step.label}}</ng-template>
      <h2 fxHide fxShow.xs>{{ step.label }}</h2>
      <formly-form [form]="form.at(index)" [model]="model" [fields]="step.fields" [options]="options[index]">
      </formly-form>
      <div class="button-container" fxLayout="row" fxLayoutAlign="center center">
        <button *ngIf="index !== 0" mat-raised-button color="primary" matStepperPrevious type="button"
          (click)="prevStep(index)">Back</button>
        <button *ngIf="!last" mat-raised-button color="primary" matStepperNext type="button"
          [disabled]="!form.at(index).valid" (click)="nextStep(index)">Next</button>
        <button *ngIf="last" mat-raised-button color="primary" [disabled]="!form.valid" type="submit">Submit</button>
      </div>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>Result</ng-template>
      <br>
      <div id='download-btn' *ngIf='stepper.selectedIndex===3'>
        <button type="button" mat-raised-button color="primary" (click)='getPDF()'>Click here to download PDF
           <mat-icon aria-hidden="false" aria-label="pdf icon">picture_as_pdf</mat-icon>
       </button>
      </div>
      <br>
      <div fxShow fxHide.xs>
        <h2 *ngIf="!isBroke && stepper.selectedIndex===3"> You will not go broke with {{responseObject.rate_of_return | percent: '1.0-2'}} rate of return.</h2>
        <h2 *ngIf="isBroke"> You will go broke in {{responseObject.years_till_broke - 1}} years with the expenses
          inputted. In order to avoid going broke, you will need a rate of return of
          {{responseObject.rate_of_return | percent: '1.0-2'}}</h2>
      </div>
      <div fxHide fxShow.xs>
        <h2 fxHide fxShow.xs>Result</h2>
        <h3 *ngIf="!isBroke && stepper.selectedIndex===3"> You will not go broke with {{responseObject.rate_of_return | percent: '1.0-2'}} rate of return</h3>
        <h3 *ngIf="isBroke"> You will go broke in {{responseObject.years_till_broke - 1}} years with the expenses
          inputted. In order to avoid going broke, you will need a rate of return of
          {{responseObject.rate_of_return | percent: '1.0-2'}}</h3>
      </div>


      <div id="chart">
        <apx-chart [series]="chartOptions.series" [chart]="chartOptions.chart" [xaxis]="chartOptions.xaxis"
          [stroke]="chartOptions.stroke" [tooltip]="chartOptions.tooltip" [dataLabels]="chartOptions.dataLabels"
          [legend]="chartOptions.legend" [markers]="chartOptions.markers" [grid]="chartOptions.grid"
          [yaxis]="chartOptions.yaxis" [title]="chartOptions.title" [colors]="chartOptions.colors"
          [responsive]="chartOptions.responsive"></apx-chart>
      </div>
      <div style="align-self: center;" class="mat-elevation-z8">
        <table mat-table matTableResponsive *ngIf="dataSource" [dataSource]="dataSource" class="result-table">
          <ng-container matColumnDef="year">
            <th mat-header-cell *matHeaderCellDef class="primary-bg"> Year </th>
            <td mat-cell *matCellDef="let calculation"> {{calculation.year}} </td>
          </ng-container>
          <ng-container matColumnDef="age">
            <th mat-header-cell *matHeaderCellDef class="primary-bg"> Age </th>
            <td mat-cell *matCellDef="let calculation"> {{calculation.age}} </td>
          </ng-container>
          <ng-container matColumnDef="startBalance">
            <th mat-header-cell *matHeaderCellDef class="primary-bg"> Start Balance </th>
            <td mat-cell *matCellDef="let calculation">
              {{calculation.startBalance }} </td>
          </ng-container>
          <ng-container matColumnDef="portfolioGain">
            <th mat-header-cell *matHeaderCellDef class="primary-bg"> Portfolio Gains </th>
            <td mat-cell *matCellDef="let calculation">
              {{calculation.portfolioGain}} </td>
          </ng-container>
          <ng-container matColumnDef="socialIncome">
            <th mat-header-cell *matHeaderCellDef class="primary-bg"> Social Security Income </th>
            <td mat-cell *matCellDef="let calculation">
              {{calculation.socialIncome}} </td>
          </ng-container>
          <ng-container matColumnDef="annualIncome">
            <th mat-header-cell *matHeaderCellDef class="primary-bg"> Annual Income </th>
            <td mat-cell *matCellDef="let calculation">
              {{calculation.annualIncome}} </td>
          </ng-container>
          <ng-container matColumnDef="annualExpense">
            <th mat-header-cell *matHeaderCellDef class="primary-bg"> Annual Expense </th>
            <td mat-cell *matCellDef="let calculation">
              {{calculation.annualExpense}} </td>
          </ng-container>
          <ng-container matColumnDef="endingBalance">
            <th mat-header-cell *matHeaderCellDef class="primary-bg"> End Balance </th>
            <td mat-cell *matCellDef="let calculation">
              {{calculation.endingBalance}} </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <mat-paginator pageSize="10" [pageSizeOptions]="[5, 10, 20, 50]" showFirstLastButtons></mat-paginator>
      </div>
    </mat-step>
  </mat-horizontal-stepper>
</form>
